/* START_MODULE_CONTRACT
 * PURPOSE: Frontend model: EmployeeAbsence.
 * SCOPE: DTO mapping / constants.
 * DEPENDS: M-FE-API
 * LINKS: M-FE-API
 * ROLE: TYPES
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * EmployeeAbsence - Frontend model: EmployeeAbsence.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-07-02 - GRACE coverage: реальный class-контракт и парный END_CLASS.
 * END_CHANGE_SUMMARY
 */

/* START_CLASS_EmployeeAbsence */
/* START_CONTRACT: EmployeeAbsence
 * PURPOSE: Клиентская модель периода отсутствия сотрудника.
 * INPUTS: { id, from, to } из API-ответа.
 * OUTPUTS: экземпляр EmployeeAbsence.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-API, M-EMPLOYEE
 * END_CONTRACT: EmployeeAbsence
 */
export default class EmployeeAbsence {
  constructor({ id, from, to }) {
    this.id = id;
    this.from = from ?? '';
    this.to = to ?? '';
  }

  static fromResponse(data) {
    return new EmployeeAbsence(data);
  }
}
/* END_CLASS_EmployeeAbsence */
